<template>
  <SideModal
    :show="show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="left"
    close-on-overlay-click
  >
    <form @submit.prevent="save" class="modal-container">
      <div class="modal-top">
        <Typography color="primary" weight="600" size="1.25rem">Add Teacher</Typography>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <div class="modal-body">
        <v-text-field
          class="custom-input"
          color="primary"
          label="Title"
          v-model="state.teacher_title"
        ></v-text-field>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="First Name"
            v-model="state.teacher_fname"
          ></v-text-field>
          <FormValidate
            :validate="state.teacher_fname"
            :regex="/.{1,50}/"
            title="First name must be a string of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Last Name"
            v-model="state.teacher_lname"
          ></v-text-field>
          <FormValidate
            :validate="state.teacher_lname"
            :regex="/.{1,50}/"
            title="Last name must be a string of 1 to 50 characters"
          ></FormValidate>
        </div>
        <v-text-field
          class="custom-input"
          color="primary"
          label="Class Description"
          v-model="state.teacher_classes"
        ></v-text-field>
        <v-text-field
          class="custom-input"
          color="primary"
          label="Room"
          v-model="state.room_assignment"
        ></v-text-field>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="E-Mail"
            v-model="state.email"
          ></v-text-field>
          <FormValidate
            title="Email is a required field"
            :validate="state.email"
            email
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Phone Number"
            v-model="state.phone"
          ></v-text-field>
          <FormValidate
            :validate="state.phone"
            :regex="/^.{0,15}$/"
            title="Phone Number must be a string of 0 to 15 characters"
          ></FormValidate>
        </div>
        <div>
          <v-btn
            width="100%"
            type="submit"
            :loading="state.loadingSave"
            style="text-transform: capitalize"
            >Save</v-btn
          >
        </div>
      </div>
    </form>
  </SideModal>
</template>

<script setup lang="ts">
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import useTeachers from "@/stores/school/teachers";
import FormValidate from "@/components/formValidate.vue";

const props = defineProps<{
  show: boolean;
}>();

const teachersS = useTeachers();

const state = reactive({
  loadingSave: false,
  teacher_title: "",
  teacher_fname: "",
  teacher_lname: "",
  teacher_classes: "",
  room_assignment: "",
  email: "",
  external_id: "",
  phone: ""
});

watch([() => props.show], () => {
  Object.assign(state, {
    loadingSave: false,
    teacher_title: "",
    teacher_fname: "",
    teacher_lname: "",
    teacher_classes: "",
    room_assignment: "",
    email: "",
    external_id: "",
    phone: ""
  });
});

const emit = defineEmits<{
  (e: 'update:show', ...args: any[]): void;
  (e: 'update:search', ...args: any[]): void
}>();

const save = async () => {
  state.loadingSave = true;
  // add teacher

  const res = await teachersS.createTeacher({
    teacher_title: state.teacher_title,
    teacher_fname: state.teacher_fname,
    teacher_lname: state.teacher_lname,
    teacher_classes: state.teacher_classes,
    room_assignment: state.room_assignment,
    email: state.email,
    phone: state.phone
  });

  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "Added teacher successfully" : "Failed to add new teacher, try again later",
    7
  );
  if (res) emit("update:search", state.email);
  state.loadingSave = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
